/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NetSuiteFulfillment
 */
export interface NetSuiteFulfillment {
  /**
   *
   * @type {string}
   * @memberof NetSuiteFulfillment
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteFulfillment
   */
  tranId?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteFulfillment
   */
  linkedShipment?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteFulfillment
   */
  orderId?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteFulfillment
   */
  orderTranId?: string | null;
  /**
   *
   * @type {string}
   * @memberof NetSuiteFulfillment
   */
  orderType?: string | null;
}

/**
 * Check if a given object implements the NetSuiteFulfillment interface.
 */
export function instanceOfNetSuiteFulfillment(
  value: object,
): value is NetSuiteFulfillment {
  return true;
}

export function NetSuiteFulfillmentFromJSON(json: any): NetSuiteFulfillment {
  return NetSuiteFulfillmentFromJSONTyped(json, false);
}

export function NetSuiteFulfillmentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): NetSuiteFulfillment {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    tranId: json["tranId"] == null ? undefined : json["tranId"],
    linkedShipment:
      json["linkedShipment"] == null ? undefined : json["linkedShipment"],
    orderId: json["orderId"] == null ? undefined : json["orderId"],
    orderTranId: json["orderTranId"] == null ? undefined : json["orderTranId"],
    orderType: json["orderType"] == null ? undefined : json["orderType"],
  };
}

export function NetSuiteFulfillmentToJSON(json: any): NetSuiteFulfillment {
  return NetSuiteFulfillmentToJSONTyped(json, false);
}

export function NetSuiteFulfillmentToJSONTyped(
  value?: NetSuiteFulfillment | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value["id"],
    tranId: value["tranId"],
    linkedShipment: value["linkedShipment"],
    orderId: value["orderId"],
    orderTranId: value["orderTranId"],
    orderType: value["orderType"],
  };
}
